<template>
  <div class="studio_video_mask_layer" v-if="youtubeVideoId">
    <button class="video_close" @click="handleClickCloseStudioVideoMask">&times;</button>
    <div class="video_box">
      <div class="youtubeCard">
        <div class="loading-mask" v-if="isLoading">
          <div class="spinner"></div>
        </div>
        <youtube v-if="youtubeId"
            :video-id="youtubeId"
            :player-vars="playerVars"
            @ready="onPlayerReady"
            class="youtube-video"
        ></youtube>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "youtubeVideo",
  data() {
    return {
      youtubeId:'',
      isLoading:false,
      playerVars: {
        autoplay: 1, // 不自动播放
        controls: 1, // 显示控制条
        rel: 0, // 播放结束后不显示相关视频
        showinfo: 0,
        modestbranding: 1,
      },
    };
  },
  props: {
    youtubeVideoId: {
      type: String,
      default: ''
    }
  },
  created(){
    this.youtubeId = this.youtubeVideoId
    this.isLoading = true
  },
  methods: {
    onPlayerReady() {
      this.isLoading = false
    },
    handleClickCloseStudioVideoMask(){
      this.$emit("update:youtubeVideoId", '')
    }
  }
}
</script>

<style scoped lang="scss">
.studio_video_mask_layer{
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  padding: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .video_close{
    width: 54px;
    height: 54px;
    line-height: 54px;
    border-radius: 50%;
    font-size: 24px;
    color: #fff;
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .video_box{
    width: 70%;
    height: 80%;
    video{
      max-width: 100%;
      height: 100%;
      margin: 0 auto;
      display: block;
    }
    .youtubeCard {
      width: 100%;
      height: 100%;
      background-color: #262626;
      position: relative;
      .loading-mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
        .spinner {
          width: 70px;
          height: 70px;
          border: 6px solid rgba(255, 255, 255, 0.1);
          border-top-color: #fff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        /* 定义转动动画 */
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      }
    }
    :deep {
      .youtube-video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .studio_video_mask_layer .video_box{
    width: 90%;
    height:280px;
  }
}
</style>
